import React from "react";
import { Dialog } from "../../base/Dialog/Dialog.jsx";
import { Button, buttonThemeColors } from "../../base/Button/Button.jsx";
import { GridContainerFlex } from "../../layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import { GridItemFlex } from "../../layout/GridFlex/GridItemFlex/GridItemFlex.jsx";

export const ConfirmationDialog = ({
    title,
    onClose,
    description,
    action,
    confirmBtnText = "YES",
    cancelBtnText = "NO",
    width = 500,
    textAlign = "center",
    buttonAlign = "center",
    disabled = false,
    ...otherProps
}) => {
    const justifyContent = buttonAlign === "flex-start" ? "start" : 
                         buttonAlign === "flex-end" ? "end" : "center";

    return (
        <Dialog
            title={title}
            onClose={onClose}
            width={width}
            {...otherProps}
        >
            <GridContainerFlex direction="column" gap="16px">
                <GridItemFlex style={{ textAlign }}>
                    <span>{description}</span>
                </GridItemFlex>
                <GridItemFlex>
                    <GridContainerFlex gap="8px" justifyContent={justifyContent}>
                        <GridItemFlex>
                            <Button
                                themeColor={buttonThemeColors.primary}
                                onClick={action}
                                disabled={disabled}
                            >
                                {confirmBtnText}
                            </Button>
                        </GridItemFlex>
                        <GridItemFlex>
                            <Button
                                themeColor={buttonThemeColors.base}
                                onClick={onClose}
                            >
                                {cancelBtnText}
                            </Button>
                        </GridItemFlex>
                    </GridContainerFlex>
                </GridItemFlex>
            </GridContainerFlex>
        </Dialog>
    );
};